import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import {
  Affiliate,
  ClientRequestSI,
  ClientResponseSI,
  TakerInterface,
} from '@views/interfaces/services/client.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private _http: HttpClient) {}

  async getClient(idProject: string): Promise<ClientResponseSI> {
    idProject = idProject ? idProject : '';
    const result = await firstValueFrom<ResponseCommonSI<ClientResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.GET_CLIENT}/${idProject}`)
    );
    return result.payload;
  }

  async getAfiliates(rut: string): Promise<TakerInterface> {
    const result = await firstValueFrom<ResponseCommonSI<TakerInterface>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.TAKER_NEW.replace(':rut', rut)}`)
    );
    return result.payload;
  }

  async saveClient(body: ClientRequestSI): Promise<{idProject: string}> {
    const result = await firstValueFrom<ResponseCommonSI<{idProject: string}>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.CLIENT}`, body)
    );
    return result.payload;
  }
}
